export default class DapGeoLocFixCallbackController {
	static $inject = ['$scope', '$state', '$uibModal', 'registresService', 'notification', '$translate'];

	constructor($scope, $state, $uibModal, registresService, notification, $translate) {
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.registresService = registresService;
		this.notification = notification;
		this.$translate = $translate;
		this.result = [];
	}

	async $onInit() {
		this.result = this.resolve.result.data;
	}

	async relancer(bool) {
		this.loading = true;
		try {
			const res = await this.resolve.getDapGeoVerification(bool);
			this.result = res?.data ?? [];
			if (this.result.length === 0) {
				this.notification.success(await this.$translate('REGISTRES.DAP_GEO_LOC.COORDONNEES_CORRIGEES'));
				this.dismiss();
			} else {
				this.retryFailed = true;
			}
		} catch (ex) {
			this.notification.error(await this.$translate('REGISTRES.ERREUR_CORRECTION'));
		}
		this.loading = false;
	}
}
